/* eslint-disable react/no-array-index-key */
import { faAngleLeft } from '@fortawesome/pro-light-svg-icons/faAngleLeft';
import { faAngleRight } from '@fortawesome/pro-light-svg-icons/faAngleRight';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Property } from '@propertypal/shared/src/types/property';
import React, { FunctionComponent, useState } from 'react';
import { useTheme } from 'styled-components';
import 'swiper/css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { SubHeading } from '../typography';
import { Container, LeftArrow, Content, RightArrow } from './RecentPropertiesHome.style';
import RecentPropertyBox from './RecentPropertyBox';

interface Props {
  properties: Property[];
}

const chunkProperties = (properties: Property[]) => {
  const chunks: Array<Property[]> = [];

  properties.forEach((property, index) => {
    if (index % 3 === 2) {
      chunks[chunks.length - 1].push(property);
    } else {
      chunks.push([property]);
    }
  });

  return chunks;
};

const RecentPropertiesHome: FunctionComponent<Props> = (props) => {
  const { properties } = props;
  const [swiper, setSwiper] = useState<any>(null);
  const theme = useTheme();
  const chunks = chunkProperties(properties);

  return (
    <Container>
      <SubHeading mb={30} lineHeight={43} fontSize={36}>
        Recently Added Properties
      </SubHeading>

      <Content>
        <LeftArrow onClick={() => swiper?.slidePrev()} aria-label="Move slider left">
          <FontAwesomeIcon icon={faAngleLeft} color={theme.white} style={{ fontSize: 80 }} />
        </LeftArrow>

        <RightArrow onClick={() => swiper?.slideNext()} aria-label="Move slider right">
          <FontAwesomeIcon icon={faAngleRight} color={theme.white} style={{ fontSize: 80 }} />
        </RightArrow>

        <Swiper centeredSlides onSwiper={setSwiper} simulateTouch slidesPerView="auto" spaceBetween={10} loop>
          {chunks.map((chunk, index) => (
            <SwiperSlide key={index} style={{ width: 280 }}>
              {chunk.map((property) => (
                <RecentPropertyBox key={property.id} property={property} isLarge={!(index % 2)} />
              ))}
            </SwiperSlide>
          ))}
        </Swiper>
      </Content>
    </Container>
  );
};

export default RecentPropertiesHome;
